import { Axios } from 'src/class/Axios.js';

const mixinFarm = {
  methods: {
    getFarmListByBusinesses(farms, businesses) {
      let resp = [];
      let businessesIds = [...new Set(businesses)];

      if (businessesIds.length === 1 && Number(businessesIds[0]) === 0)
        resp = farms ? farms : [];
      else if (businessesIds.length > 0) {
        if (farms) {
          farms.forEach((farm) => {
            if (farm.businesses) {
              const result = farm.businesses.find((item) =>
                businessesIds.includes(item.id)
              );
              if (result) resp.push(farm);
            }
          });
        }
      } else resp = farms ? farms : [];

      return resp;
    },

    async getLotsByFarm(farmsSelecteds, listFarms) {
      const farmsId = farmsSelecteds.filter((id) => Number(id) !== 0);
      let lots = [];
      const allLots = [];

      await Promise.all(
        farmsId.map((farmId) => {
          return Axios.getMasters('lots/' + farmId)
            .then((response) => {
              const farm = listFarms.find((farm) => farm.id === farmId);
              response.data.data.forEach(
                (lot) => (lot.name = lot.name + ' - ' + farm.name)
              );
              return lots = response.data.data;
            })
            .catch((error) => {
              console.error(
                `Error fetching lots for farm ID ${farmId}:`,
                error
              );
              return [];
            });
        })
      )
        .then((lotsArrays) => {
          allLots.push(...lotsArrays.flat());
        })
        .catch((error) => {
          console.error('Error fetching lots:', error);
        });

      return allLots;
    }
  },
};

export default mixinFarm;
